import {
  Component,
  HostListener,
  Input,
  OnInit,
  QueryList,
  ViewChildren,
  ViewContainerRef
} from '@angular/core';
import { isBs3 } from '../utilities/ng2-bootstrap-config';
import { DatePickerInnerComponent } from './datepicker-inner.component';
import { DatepickerService } from './datepicker.shared.service';
import * as moment_ from '../utilities/lib-moment/moment-with-locales.custom.min';
import { getBrowserLocale } from './datepicker-utility';
const moment = moment_;
@Component({
  selector: 'axis-yearpicker',
  templateUrl: './yearpicker.component.html'
})
export class YearPickerComponent implements OnInit {
  public datePicker: DatePickerInnerComponent;
  public title: string;
  public title1: any;
  public rows: any[] = [];
  public selectedYear: any;
  public selectedYearNumber: any;
  public localeLanguage: string;
  public japanLocale = false;
  public validKeyPressed = false;
  public localeStart: any;
  @Input() isReadOnly: boolean;
  @ViewChildren('yearRef') yearRef: QueryList<ViewContainerRef>;

  public constructor(
    datePicker: DatePickerInnerComponent,
    private datepickerService: DatepickerService
  ) {
    this.datePicker = datePicker;
  }

  public get isBs4(): boolean {
    return !isBs3();
  }

  public ngOnInit(): void {
    let self: any = '';
    self = this;
    this.datePicker.stepYear = { years: this.datePicker.yearRange };
    this.datePicker.setRefreshViewHandler(function(): void {
      const useLocale  = self.datepickerService.useLocale;
      this.localeLanguage = (useLocale) ? useLocale : getBrowserLocale();
      moment.locale(this.localeLanguage);
      this.years = new Array(this.yearRange);
      let date: Date;
      this.currentYear = this.activeDate.getFullYear();
      // currentYear : Defines the next possible year, while navigating across the yearPicker.
      this.start = this.start ? this.start : new Date().getFullYear();
       // start : Defines the first position of an year from where the years gets loaded in yearPicker.
      this.localeStart = this.localeStart ? this.localeStart : new Date().getFullYear() - 9;
       // localeStart : Defines the Custom position of a year on the yearPicker
        self.datepickerService.inputElement.subscribe(result => {
          const inputValue = this._activeDate;
          if (inputValue === '') {
              if (this.localeLanguage === 'ja') {
                this.editableStartValue = new Date().getFullYear() - 9;
              } else {
                this.editableStartValue = new Date().getFullYear();
              }
          } else {
            if (this.localeLanguage === 'ja') {
              this.editableStartValue = new Date(inputValue).getFullYear() - 9;
            } else {
              this.editableStartValue = new Date(inputValue).getFullYear();
            }
          }
          this.start = this.editableStart ? this.editableStart : this.editableStartValue;
        });
  

      for (let i = 0; i < this.yearRange; i++) { // This loop loads the years on yearPicker in onload condition.
        date = new Date(this.start + i, 0, 1);
        date = this.fixTimeZone(date);
        this.years[i] = this.createDateObject(date, this.formatYear);
        this.years[i].uid = this.uniqueId + '-' + i;
      }

      if (this.years.length === this.yearRange) {
        const refYear = this.years[this.yearRange - 1].label;
        const selectedRefYear = parseInt(refYear, 10); // selectedRefYear : Gets the value of a last postioned year from the year picker.
        let startYear;
        if (this.currentYear > selectedRefYear) {
          // This condition loads the years on yearPicker while navigating yearPicker from present years to future years.
          if (this.localeLanguage === 'ja') {
            if (!this.isReadOnly) {
              this.editableStart = selectedRefYear + 1;
              startYear = this.editableStart;
            } else {
              this.localeStart = selectedRefYear + 1;
              startYear = this.localeStart;
            }
          } else {
            if (!this.isReadOnly) {
              this.editableStart = selectedRefYear + 1;
              startYear = this.editableStart;
            } else {
              this.start = selectedRefYear + 1;
              startYear = this.start;
            }
          }
        } else if (this.currentYear < this.start) {
          // This condition loads the years on yearPicker while navigating yearPicker from present years to past years.
          if (this.localeLanguage === 'ja') {
            if (!this.isReadOnly) {
              this.editableStart = this.start - this.yearRange;
              startYear = this.editableStart;
            } else {
              this.localeStart = this.localeStart - this.yearRange;
              startYear = this.localeStart;
            }
          } else {
            if (!this.isReadOnly) {
              this.editableStart = this.start - this.yearRange;
              startYear = this.editableStart;
            } else {
              this.start = this.start - this.yearRange;
              startYear = this.start;
            }
          }
        } else {
          startYear = this.start;
        }

        for (let i = 0; i < this.yearRange; i++) {
          date = new Date(startYear + i, 0, 1);
          date = this.fixTimeZone(date);
          this.years[i] = this.createDateObject(date, this.formatYear);
          this.years[i].uid = this.uniqueId + '-' + i;
        }
      }

      self.title = [
        this.years[0].label,
        this.years[this.yearRange - 1].label
      ].join(' - ');

      self.rows = this.split(this.years, self.datePicker.yearColLimit);

      if (this.localeLanguage === 'ja') {
        self.japanLocale = true;
        let k = 0;
        for (let i = 0; i < 4; i++) {
          for (let j = 0; j < 5; j++) {
            const year = self.rows[i][j].label.concat('年');
            self.rows[i][j].label = year;
            k = k + 1;
          }
        }
        self.title1 = new Date(this.activeDate).getFullYear();
        const month = moment.monthsShort();
        self.title = month[new Date(this.activeDate).getMonth()];
        self.title1 = self.title1.toString().concat('年');
      }
    }, 'year');

    this.datePicker.setCompareHandler(function(
      date1: Date,
      date2: Date
    ): number {
      if (date1 !== null && date2 !== null) {
        return date1.getFullYear() - date2.getFullYear();
      }
    },
    'year');

    this.datePicker.refreshView();
  }

  // protected getStartingYear(year: number): number {
  //   const reminder = year % this.datePicker.yearRange;
  //   return reminder ? (year - reminder) : (((year - 1) / this.datePicker.yearRange) * this.datePicker.yearRange + 1);
  // }

  @HostListener('keyup', ['$event', 'this.yearRef'])
  onKeyup(e: any, yearRef: any) {
    e.preventDefault();
    this.validKeyPressed = true;
    if ((e.code !== 'Tab' || e.keyCode !== 9) && this.datePicker.datepickerMode === 'year') {
      this.yearUpdateOnKeyPress(yearRef, e);
    }
  }

  yearUpdateOnKeyPress(yearRef: any, e: any) {
    yearRef.forEach(element => {
      const tempElement = element.nativeElement;
      if (tempElement.classList.contains('date-selected') || tempElement.classList.contains('date-today')) {
        const selectedYearName = element.nativeElement.textContent;
        const selectedYearNumber = parseInt(selectedYearName, 10);
         this.selectedYear = new Date(selectedYearNumber, 0, 1);
        if (e.code === 'ArrowRight' || e.keyCode === 39) {
          this.selectedYear.setFullYear(selectedYearNumber + 1);
        } else if (e.code  === 'ArrowLeft' || e.keyCode === 37) {
          this.selectedYear.setFullYear(selectedYearNumber - 1);
        } else if (e.code === 'ArrowDown' || e.keyCode === 40) {
          this.selectedYear.setFullYear(selectedYearNumber + 5);
        } else if (e.code  === 'ArrowUp' || e.keyCode === 38) {
          this.selectedYear.setFullYear(selectedYearNumber - 5);
        } else if (e.code  === 'Home' || e.keyCode === 36) {
          this.selectedYearNumber = parseInt(this.datePicker.yearpickerref.yearRef.first['nativeElement'].children[0].innerHTML, 10);
          this.selectedYear = new Date(this.selectedYearNumber, 0, 1);
        } else if (e.code  === 'End' || e.keyCode === 35) {
          this.selectedYearNumber = parseInt(this.datePicker.yearpickerref.yearRef.last['nativeElement'].children[0].innerHTML, 10);
          this.selectedYear = new Date(this.selectedYearNumber, 0, 1);
        } else if (e.code === 'Escape' || e.keyCode === 27) {
          this.datepickerService.inputElement.subscribe(result => {
            const inputValue = result['nativeElement'].children[0].firstChild.value;
            if (inputValue === '') {
              this.datePicker.activeDate = void 0;
              this.datePicker.closeEvent.emit(this.datePicker.activeDate);
              result['nativeElement'].firstChild.children[0].focus();
            } else {
              this.datePicker.closeEvent.emit(new Date(inputValue));
              result['nativeElement'].firstChild.children[0].focus();
            }
          });
        } else if  ((e.code  === 'PageUp' || e.keyCode === 33) && e.altKey === false) {
          this.selectedYearNumber = this.datePicker['_activeDate'];
          this.selectedYear = new Date(this.selectedYearNumber.getFullYear() - 20, 0, 1);
        } else if ((e.code === 'PageDown' || e.keyCode === 34) && e.altKey === false) {
          this.selectedYearNumber = this.datePicker['_activeDate'];
          this.selectedYear = new Date(this.selectedYearNumber.getFullYear() + 20, 0, 1);
        }  else if (e.altKey === true && (e.code  === 'PageDown' || e.keyCode === 34)) {
          this.selectedYearNumber = this.datePicker['_activeDate'];
          this.selectedYear = new Date(this.selectedYearNumber.getFullYear() + 200, 0, 1);
        } else if (e.altKey === true && (e.code  === 'PageUp' || e.keyCode === 33)) {
          this.selectedYearNumber = this.datePicker['_activeDate'];
          this.selectedYear = new Date(this.selectedYearNumber.getFullYear() - 200, 0, 1);
        } else {
          this.validKeyPressed = false;
        }

        if (this.validKeyPressed) {
        this.datePicker.select(this.selectedYear, false);
        }
        if (e.code  === 'Enter' || e.keyCode === 13)  {
          this.datePicker.select(this.selectedYear, true);
          this.datepickerService.inputElement.subscribe(result => {
            result['nativeElement'].firstChild.children[0].focus();
        });
        }
      }
    });
  }
}
